"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "miglianico": {
    "99bc0e6e": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "cagialone": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17a650fe": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99081359": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "collemarino": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a39fa47b": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "elcine": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "275ef649": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "foreste": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05c7f656": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }],
    "piane-san-pantaleone-e-valle-sant-angelo": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "montupoli": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5297e933": [{
      "hkey": "892e8354",
      "slug": "miglianico",
      "name": "Miglianico",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;